import { LogFilterData } from '@modules/activities/ActivityLogPage/ActivityLogPage';

export enum ActivityModule {
  ACCOUNT = 'account',
  PROJECTS = 'projects',
  CONTACT = 'contacts',
  BILLING = 'billing',
  TICKETING = 'ticketing',
  SUBSCRIPTIONS = 'subscriptions',
  ORDER = 'order',
  ESTIMATE = 'estimates',
  // The master catalog and its configuration, one module per area (CatalogActivityHelper::moduleKey)
  PRODUCTS = 'products',
  PRODUCT_PRICING = 'product-pricing',
  VENDOR_PRICING = 'vendor-pricing',
  PRODUCT_FORMULAS = 'product-formulas',
  CATEGORIES = 'categories',
  CATEGORY_OPTIONS = 'category-options',
  VENDOR_PRIORITY = 'vendor-priority',
  VENDORS = 'vendors',
  ESTIMATE_TEMPLATES = 'estimate-templates',
  ESTIMATE_TEMPLATE_LIST = 'estimate-template-list',
  ESTIMATE_FEES = 'estimate-fees',
  ROLLUPS = 'rollups',
  REGIONS = 'regions',
  DISCOUNT_TYPES = 'discount-types',
  CHANGE_ORDER_TYPES = 'change-order-types',
}

export interface LogLinkResponse {
  text: string;
  link: string;
}

export type LogId = string;
export interface LogResponse {
  logId: LogId;
  createdAt: number;
  createdBy: {
    id: string;
    name: string;
  };

  action: 'create' | 'delete' | 'update';
  type: string;

  title: string;
  details: string;
  bolds: string[];
  links: LogLinkResponse[];

  module: ActivityModule;

  xEntry: XEntryResponse | null;
  /** The record the entry is about, e.g. "product:12" (catalog entries); the page's record filter */
  recordKey?: string;
}

export interface XEntryResponse {
  changes: string[];
  new: Record<string, any>;
  old: Record<string, any>;
  /** Catalog entries: the area (e.g. "Vendor Pricing"), the reason the user gave, the vendor, and the record */
  area?: string;
  note?: string | null;
  provider?: string | null;
  record?: { key: string; name: string };
}

export interface LogRequest extends LogFilterData {
  after?: number;
}
